import { useState } from "react";
import { Button, DropdownMenu, Icon, Modal, Typography } from "@/components/atoms";
import { getErrorMessages } from "@/helpers/reduxHelpers";
import { useUnblockDriverMutation } from "@/redux/apis/clientDispatch/clientDispatchApi";
import { BlockedDriver } from "@/redux/apis/clientDispatch/types";
import { addToast } from "@/utils";

interface UnblockDriverActionProps {
  driver: BlockedDriver;
  accountId?: string;
}

export const UnblockDriverAction = ({ driver, accountId }: UnblockDriverActionProps) => {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [unblockDriver, { isLoading }] = useUnblockDriverMutation();

  const handleUnblock = () => {
    unblockDriver({ restrictionUuid: driver.restrictionUuid, accountId })
      .unwrap()
      .then(() => {
        addToast("success", `${driver.driverName} has been unblocked.`);
        setIsConfirmOpen(false);
      })
      .catch((error) => addToast("danger", getErrorMessages(error)[0]));
  };

  return (
    <>
      <DropdownMenu
        button={
          <DropdownMenu.Button aria-label="Driver actions" className="inline-flex items-center justify-center text-neutral-black">
            <Icon name="options" isCustom size="lg" />
          </DropdownMenu.Button>
        }
        isCustomButton
        position="bottom-end"
      >
        <DropdownMenu.Item onClick={() => setIsConfirmOpen(true)} className="w-56">
          <Icon name="Refresh2" size="sm" className="mr-2.5 flex-shrink-0 text-primary-dark" />
          <Typography className="text-primary-dark">Unblock Driver</Typography>
        </DropdownMenu.Item>
      </DropdownMenu>

      <Modal
        open={isConfirmOpen}
        onClose={() => setIsConfirmOpen(false)}
        variant="web-small"
        title="Unblock Driver"
        renderButtons={() => (
          <>
            <Button variant="tertiary" size="md" onClick={() => setIsConfirmOpen(false)} disabled={isLoading}>
              Cancel
            </Button>
            <Button
              variant="primary"
              size="md"
              className="border-danger bg-danger hover:bg-danger-dark"
              onClick={handleUnblock}
              disabled={isLoading}
            >
              Remove
            </Button>
          </>
        )}
      >
        <Typography className="text-neutral-dark-gray">
          Are you sure you want to unblock <span className="text-info">{driver.driverName}</span> from your blocked list?
        </Typography>
      </Modal>
    </>
  );
};
